export default __webpack_public_path__ + "static/media/zjedz.39ffb4bb.png";